// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__JB_dC","question":"Question_question__1eOtE","description":"Question_description__3v0U-"};